import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { Field } from 'kts-scaffold-framework/utils/doc';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
 
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class Footer extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        return (
            <div className={css['input-settlement-detail-footer']}>
             <div className={css['count-footer']}>

                    <p>合计</p>
                    {/* <div>
                        数量： <span>{props.info && props.goodsLength}</span>
                    </div> */}
                    <div>
                        无税金额：<span>
                        {Field.formatMoney(this.modulesState.detailInfo &&this.modulesState.detailInfo.amountWithoutTax, 2)}
                        </span>
                    </div>
                    <div>
                        税额：<span>{Field.formatMoney(this.modulesState.detailInfo && this.modulesState.detailInfo.amountTax, 2)}</span>
                    </div>
                    <div>
                        税价合计：<span>{Field.formatMoney(this.modulesState.detailInfo && this.modulesState.detailInfo.amountSum, 2)}</span>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.Detail.Footer.tsx